var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ESLEventUtils } from '@exadel/esl/modules/esl-utils/dom';
import { listen } from '@exadel/esl/modules/esl-utils/decorators';
export class UIPStateStorage {
    constructor(storeKey, model) {
        this.storeKey = storeKey;
        this.model = model;
        ESLEventUtils.subscribe(this);
    }
    loadEntry(key) {
        const entry = (this._lsState[key] || {});
        if (parseInt(entry === null || entry === void 0 ? void 0 : entry.ts, 10) + UIPStateStorage.EXPIRATION_TIME > Date.now())
            return entry.snippets || null;
        this.removeEntry(key);
        return null;
    }
    saveEntry(key, value) {
        this._lsState = Object.assign(this._lsState, { [key]: { ts: Date.now(), snippets: value } });
    }
    removeEntry(key) {
        const data = this._lsState;
        delete this._lsState[key];
        this._lsState = data;
    }
    get _lsState() {
        return JSON.parse(localStorage.getItem(UIPStateStorage.STORAGE_KEY) || '{}');
    }
    set _lsState(value) {
        localStorage.setItem(UIPStateStorage.STORAGE_KEY, JSON.stringify(value));
    }
    getStateKey() {
        const { activeSnippet } = this.model;
        if (!activeSnippet || !this.storeKey)
            return null;
        return JSON.stringify({ key: this.storeKey, snippet: activeSnippet.html });
    }
    loadState() {
        const stateKey = this.getStateKey();
        const state = stateKey && this.loadEntry(stateKey);
        if (!state)
            return;
        const stateobj = JSON.parse(state);
        this.model.setHtml(stateobj.html, this, true);
        this.model.setJS(stateobj.js, this);
        this.model.setNote(stateobj.note, this);
    }
    saveState() {
        const stateKey = this.getStateKey();
        const { js, html, note } = this.model;
        stateKey && this.saveEntry(stateKey, JSON.stringify({ js, html, note }));
    }
    resetState(source) {
        const stateKey = this.getStateKey();
        stateKey && this.removeEntry(stateKey);
        this.model.reset(source, this);
    }
    _onModelChange() {
        this.saveState();
    }
    _onSnippetChange() {
        this.loadState();
    }
}
UIPStateStorage.STORAGE_KEY = 'uip-editor-storage';
UIPStateStorage.EXPIRATION_TIME = 3600000 * 12; // 12 hours
__decorate([
    listen({ event: 'uip:model:change', target: ($this) => $this.model })
], UIPStateStorage.prototype, "_onModelChange", null);
__decorate([
    listen({ event: 'uip:model:snippet:change', target: ($this) => $this.model })
], UIPStateStorage.prototype, "_onSnippetChange", null);
